import {
  AgentDetail,
  AgentName,
  Avatar,
  ButtonContainer,
  Card,
  Column,
  Container,
  CoverImage,
  CustomLink,
  CustomStatusContainer,
  DetailCard,
  DetailColumn,
  DetailContainer,
  DetailName,
  DetailRow,
  DetailTitle,
  DetailValue,
  LinksContainer,
  Occupation,
  PrimaryButton,
  Row,
  VerificationDocumation,
  WhiteButton
} from './style';
import { ReactComponent as LocationIcon } from '../../../assets/location_icon.svg';
import { ReactComponent as Call } from '../../../assets/call.svg';
import { ReactComponent as Profile } from '../../../assets/profile.svg';
import { Navigate, useLocation } from 'react-router-dom';
import { ILifestyleUser } from '../../../store/lifeStyle/interface';
import { useState } from 'react';
import { ActionBtn, AgentAvatar, AgentContainer } from '../users/style';
import { currencyFormatter } from '../../../utils/currencyConverter';
import { ConfirmModal } from '../modal/confirmModal';
import { useEditLifestyleAgentVerificationMutation } from '../../../store/lifeStyle/api';
import { showErrorToast, showSuccessToast } from '../../../utils/toast';
import { Loader } from '../../../component/loader';
import {
  Table,
  TableHead,
  TableRow,
  TH,
  TableBody,
  TableData
} from '../../../component/table';

export const ViewUser = () => {
  const { hash, state } = useLocation();
  const [user, setUser] = useState(state as ILifestyleUser);
  const [confirmModal, setConfirmModal] = useState(false);
  const [editLifestyleAgentVerification, { isLoading }] =
    useEditLifestyleAgentVerificationMutation();

  const handleConfirm = (adminVerified: boolean) => {
    editLifestyleAgentVerification({
      agent: user._id,
      adminVerified: adminVerified
    })
      .unwrap()
      .then((res) => {
        setUser(res.data);
        setConfirmModal(false);
        showSuccessToast(res.message);
      })
      .catch((err) => {
        showErrorToast(err.message);
      });
  };

  if (!state) return <Navigate to={'/verification'} />;
  return (
    <Container>
      {confirmModal && (
        <ConfirmModal
          isLoading={isLoading}
          cancelBtnClick={() => setConfirmModal(false)}
          confirmBtnClick={() => handleConfirm(true)}
        />
      )}
      {isLoading && !confirmModal && <Loader />}

      <Card>
        <CoverImage src={user.coverPicture.url} alt="agent cover photo" />
        <DetailContainer>
          <Avatar src={user.avatar.url} alt="agent profile" />
          <Column>
            <AgentName>{`${user.firstname} ${user.lastname}`}</AgentName>
            <Row>
              <Call />
              <AgentDetail>{user?.phone || 'N/A'}</AgentDetail>
            </Row>
            <Row>
              <LocationIcon />
              <AgentDetail>{user.address || 'N/A'}</AgentDetail>
            </Row>
            <Row>
              <Profile />
              <AgentDetail>{user?.gender || 'N/A'}</AgentDetail>
            </Row>
            <Row>
              <Occupation>{user.category.title}</Occupation>
            </Row>
            <Row>
              <LinksContainer>
                <CustomLink
                  active={`${hash.includes('#profile')}`}
                  to={'#profile'}
                  state={user}
                >
                  Profile
                </CustomLink>
                <CustomLink
                  active={`${hash.includes('#services')}`}
                  to={'#services'}
                  state={user}
                >
                  Services
                </CustomLink>
                <CustomLink
                  active={`${hash.includes('#verification')}`}
                  to={'#verification'}
                  state={user}
                >
                  Verification
                </CustomLink>
              </LinksContainer>
            </Row>
          </Column>
          <CustomStatusContainer status={user.adminVerified}>
            {user.adminVerified ? 'VERIFIED' : 'NOT VERIFIED'}
          </CustomStatusContainer>
        </DetailContainer>
      </Card>
      <DetailCard>
        <DetailTitle>{hash.replace('#', '')}</DetailTitle>
        {hash.includes('#profile') && (
          <>
            <DetailRow>
              <DetailColumn>
                <DetailName>Business name</DetailName>
                <DetailValue>{user.displayName}</DetailValue>
              </DetailColumn>
              <DetailColumn>
                <DetailName>Address</DetailName>
                <DetailValue>{user.address || 'N/A'}</DetailValue>
              </DetailColumn>
              <DetailColumn>
                <DetailName>Service category</DetailName>
                <DetailValue>{user.category.title}</DetailValue>
              </DetailColumn>
            </DetailRow>
            <div>
              <DetailName>About</DetailName>
              <DetailValue>{user.about}</DetailValue>
            </div>
          </>
        )}
        {hash.includes('#services') && (
          <>
            <Table>
              <TableHead>
                <TableRow>
                  <TH>S/N</TH>
                  <TH>Service type</TH>
                  <TH>Amount</TH>
                  <TH>Action </TH>
                </TableRow>
              </TableHead>
              <TableBody>
                {user.services.map((data, index) => (
                  <TableRow key={data._id}>
                    <TableData>{++index}</TableData>
                    <TableData>
                      <AgentContainer>
                        <AgentAvatar alt="" src={data.service.file.url} />
                        <div>
                          <p>{data.service.title}</p>
                        </div>
                      </AgentContainer>
                    </TableData>
                    <TableData>{`N${currencyFormatter(data.price)}`}</TableData>
                    <TableData>
                      <ActionBtn onClick={() => {}}>Delete</ActionBtn>
                    </TableData>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </>
        )}
        {hash.includes('#verification') && (
          <>
            <Row>
              <DetailValue>
                <span>Note : </span>
                The details submitted by the agent must be properly vetted and
                authenticated before verification, as the security of our
                customers depends greatly on it.
              </DetailValue>
              <ButtonContainer>
                {!user.adminVerified && (
                  <>
                    <PrimaryButton onClick={() => setConfirmModal(true)}>
                      Verifiy
                    </PrimaryButton>
                    <WhiteButton onClick={() => handleConfirm(false)}>
                      Reject
                    </WhiteButton>
                  </>
                )}
              </ButtonContainer>
            </Row>
            <div>
              <DetailName>Details and description</DetailName>
              <DetailValue>{user.personalDocument.type}</DetailValue>
            </div>
            <a
              rel={'noreferrer'}
              target={'_blank'}
              href={user.personalDocument.file.url}
            >
              <VerificationDocumation
                src={user.personalDocument.file.url}
                alt=""
              />
            </a>
          </>
        )}
      </DetailCard>
    </Container>
  );
};
